import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=bdf127ec&scoped=true&"
import script from "./OfferDetails.vue?vue&type=script&lang=js&"
export * from "./OfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=bdf127ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf127ec",
  null
  
)

export default component.exports